import React from 'react';
import xtend from 'xtend';
import struct from 'observ-struct';

import ObservApi from '../lib/observable-api.js';
import DomainStore from './DomainStore';
import PreferenceController from './Controller';
import schema from '../routes/permissions/schema.js';
import PlayerManager from './player/PlayerManager.js';
import ListingManager from './listing/ListingManager.js';

export default function (domainName, api, credentials) {

    var domainApi = ObservApi(api);
    var domainStore = DomainStore(domainName, domainApi.bus);

    var state = window.domainState = struct({
        preferences: domainStore.state
    });

    class PrefRoute extends React.Component {
        render () {

            let linkTo, permissionCheck, Manager
            if (domainName === 'listing') {
                linkTo = '/manage/listing/edit'
                permissionCheck = schema.MANAGE_CLIENT_CHANNEL_SETTINGS.CREATE
                Manager = ListingManager
            } else {
                linkTo = '/manage/player/edit'
                permissionCheck = schema.MANAGE_CLIENT_PLAYER_SETTINGS.CREATE
                Manager = PlayerManager
            }
            // var self = this;
            var sharedProps = {
              linkTo,
              permissionCheck,
              Manager,
              domainName,
              store: state,
              actions: xtend(domainApi.actions, {
                delete: function (params) {
                  domainApi.actions.delete(params)
                },
              }),
            }
            return <PreferenceController {...this.props} {...sharedProps}/>
        }
    }

    return PrefRoute;
};
